<google-map 
  [center]="center"
  [zoom]="zoom"
  height="100vh"
  width="100%">
  <map-marker [position]="markerPosition"></map-marker>
</google-map>
